import React, { useRef, useMemo, useCallback } from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Daybook } from 'models/DaybookModel';
import { Denomination, PaymentMode } from 'models/BaseModel';
import { Payment } from 'models/PaymentModel';
import { Payout } from 'models/PayoutModel';
// import AsyncSelect from 'react-select/async';
// import AutoCompleteInput from 'components/common/AutoCompleteInput'
// import { Appointment } from 'models/AppointmentModel';
// import { LIMIT } from 'styled-components/dist/utils/createWarnTooManyClasses';

const DaybookForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.DAYBOOK, Code.Form.Name.DAYBOOK];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Daybook>({});
  const [lastDaybookData, setLastDaybookData] = useState<Daybook[]>([]);
  const [denominationData, setDenominationData] = useState<Denomination>({});
  const [paymentModeData, setPaymentModeData] = useState<PaymentMode[]>([]);
  const [denominationTotal, setDenominationTotal] = useState<number>(0);
  const [paymentData, setPaymentData] = useState<Payment[]>([]);
  const [payoutData, setPayoutData] = useState<Payout[]>([]);
  const todayDate = new Date(`${Utility.Date.getLocalDate().toISOString().split('T')[0]}T10:00:00`);
  //const todayDate =  new Date(`2026-02-14T10:00:00`);
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  const locationId = Utility.Storage.LocationId();

  //fetch daybook data of the day
  useEffect(() => {
    Files.Json.API(Code.File.SEGMENT, Code.Option.Common.NOTHING, setSegmentOptions, setError);
    if(keyId===Code.Key.NEW) {
      console.log("keyId:",keyId);
      setLoading(false);
      setFormData((prevData) => ({
        ...prevData,
        daybook_date: todayDate
      }));
      console.log("todayDate---->",todayDate);
      callListData();
    }
    else {
      API.Data.GetByKeyId<Daybook>(formName, keyId, setLoading, setError)
        .then(async(data) => { if(data) {
          setActiveId(data.daybook_active); 
          const clientData = await API.Data.getClientNameNumber(data.client_id);
          Files.List.parseJsonData(data.daybook_denomination, setDenominationData);
          Files.List.parseJsonDataObject(data.daybook_data, setPaymentModeData);
          const formData = await Form.Map.Data(data);
          setFormData((prevData) => ({
            ...prevData,
            ...formData,
            ...clientData,
           }));
        }})   
        setLoading(false);
    }
  }, []);


  //fetch payment & payout of the day
  const callListData = useCallback(async () => {
      
    const paymentUrl = API.Build.FormApiEndpint(Code.Form.Name.PAYMENT, 200, Name.Payment.Date, Code.Option.Sort.ASC, {
        fields: Utility.Join.Fields([
          Name.Payment.Id, Name.Payment.Date, Name.Common.ModeId, Name.Payment.Amount, Name.Common.ModeId, Name.Common.SegmentId
        ]), 
        payment_date: todayDate.toISOString().split('T')[0],
        location_id: locationId,
      });
      await API.Data.List<Payment>(paymentUrl, setPaymentData, setError, setLoading); 
      
      const payoutUrl = API.Build.FormApiEndpint(Code.Form.Name.PAYOUT, 0, Name.Payout.Date, Code.Option.Sort.ASC, {
        fields: Utility.Join.Fields([
          Name.Payout.Id, Name.Payout.Date, Name.Common.ModeId, Name.Payout.Amount
        ]), 
        payout_date: todayDate.toISOString().split('T')[0],
        location_id: locationId,
      });
      await API.Data.List<Payout>(payoutUrl, setPayoutData, setError, setLoading); 

      const lastDaybookUrl = API.Build.FormApiEndpint(Code.Form.Name.DAYBOOK, 1, Name.Daybook.Date, Code.Option.Sort.DESC, {
        fields: Utility.Join.Fields([
          Name.Daybook.Id, Name.Daybook.Date, Name.Daybook.Denomination, Name.Daybook.CashInHand
        ]), 
        location_id: locationId,
      });
      console.log("lastDaybookUrl:",lastDaybookUrl);
      await API.Data.List<Daybook>(lastDaybookUrl, setLastDaybookData, setError, setLoading); 
    
    },[]);


  //calculate sum of amount received segment & mode of payment wise   
  useEffect(() => {
    console.log("paymentData>:", paymentData);
    if (paymentData && paymentData.length > 0) {
 
    const updatedPaymentModeData = segmentOptions.map((segment) => {
      const segmentId = segment.value;

      const terminalTotal = paymentData
        .filter(p => p.segment_id === segmentId)
        .filter(p => Code.GroupModoOfPay.TERMINAL.includes(p.mode_id ?? -1))
        .reduce((sum, p) => sum + (p.payment_amount ?? 0), 0);

      const insuranceTotal = paymentData
        .filter(p => p.segment_id === segmentId)
        .filter(p => Code.GroupModoOfPay.GOVTINSURANCE.includes(p.mode_id ?? -1))
        .reduce((sum, p) => sum + (p.payment_amount ?? 0), 0);

      const cashTotal = paymentData
        .filter(p => p.segment_id === segmentId)
        .filter(p => Code.GroupModoOfPay.CASH.includes(p.mode_id ?? -1))
        .reduce((sum, p) => sum + (p.payment_amount ?? 0), 0);

      const checkTotal = paymentData
        .filter(p => p.segment_id === segmentId)
        .filter(p => Code.GroupModoOfPay.CHEQUE.includes(p.mode_id ?? -1))
        .reduce((sum, p) => sum + (p.payment_amount ?? 0), 0);

      return {
        segment: String(segmentId),
        terminal: terminalTotal.toString(), 
        insurance: insuranceTotal.toString(),
        cash: cashTotal.toString(),
        check: checkTotal.toString(),
      };
    });

    setPaymentModeData(updatedPaymentModeData);
  }
}, [paymentData]);

  //calculate total payout
  useEffect(() => {
    if(payoutData && payoutData.length>0){
      console.log("payoutData>:",payoutData);
      const payoutTotal = payoutData.reduce((sum, item) => { return sum + Number(item.payout_amount || 0); }, 0);
      if(payoutTotal>0){
        setFormData((prevData) => ({
          ...prevData,
          daybook_payout_total: payoutTotal, 
        }));
      }
    }
  }, [payoutData]);
  

  //get last submitted datbook' cash in hand and bill demonination
  useEffect(() => {
    if(lastDaybookData && lastDaybookData.length>0){
      console.log("lastDaybookData:", lastDaybookData);
      const firstRow = lastDaybookData[0];
      if(firstRow.daybook_cash_in_hand && firstRow.daybook_cash_in_hand>0) {
        setFormData((prevData) => ({
          ...prevData,
          daybook_cash_opening: firstRow.daybook_cash_in_hand || 0, 
        }));
      }
      if(firstRow.daybook_denomination && firstRow.daybook_denomination.length>2) {
        Files.List.parseJsonData(firstRow.daybook_denomination, setDenominationData);
      }
    }
  }, [lastDaybookData]);


  //Calculate today's Cash-in-hand 
  useEffect(() => {
    const cashOpen = Number(formData.daybook_cash_opening || 0);
    const cashTotal = Number(formData.daybook_cash_total || 0);
    const PayoutTotal = Number(formData.daybook_payout_total || 0);
    const cashAdjustment = Number(formData.daybook_cash_adjustment || 0);
    const newCashInHand = (cashOpen + cashTotal + cashAdjustment) - PayoutTotal;
    
    console.log("Cash In Hand:", newCashInHand, { cashOpen, cashTotal, cashAdjustment, PayoutTotal });

    if(newCashInHand>0){
      setFormData((prevData) => ({
        ...prevData,
        daybook_cash_in_hand: Number(newCashInHand.toFixed(2)), 
      }));
    }
  }, [
    formData.daybook_cash_opening,
    formData.daybook_cash_total,
    formData.daybook_payout_total,
    formData.daybook_cash_adjustment
  ]);

  //if new daybook, fill fields with zero
  // useEffect(() => {
  //   if (segmentOptions.length > 0 && keyId === Code.Key.NEW) {
  //     const defaultData: PaymentMode[] = segmentOptions.map((segment: any) => ({
  //       segment: segment.value,
  //       terminal: "0",
  //       insurance: "0",
  //       cash: "0",
  //       check: "0",
  //     }));
  //     setPaymentModeData(defaultData);
  //   }
  // }, [segmentOptions]);


  //calcutate Grand Total
  
  useEffect(() => {
     if (paymentModeData && paymentModeData.length > 0) {
      const totalTerminal = paymentModeData.reduce((sum, item) => { return sum + Number(item.terminal || 0); }, 0);
      const totalCash = paymentModeData.reduce((sum, item) => { return sum + Number(item.cash || 0); }, 0);
      const totalInsurance = paymentModeData.reduce((sum, item) => { return sum + Number(item.insurance || 0); }, 0);
      const totalCheck = paymentModeData.reduce((sum, item) => { return sum + Number(item.check || 0); }, 0);

      setFormData((prevData) => ({
          ...prevData,
          daybook_terminal_total: totalTerminal, 
          daybook_cash_total: totalCash, 
          daybook_insurance_total: totalInsurance, 
          daybook_check_total: totalCheck, 
          daybook_grand_total: (totalTerminal + totalCash + totalInsurance + totalCheck)
        }));
    }
  }, [paymentModeData]);

  //save daybook data on click on save button
  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;

    if(lastDaybookData && lastDaybookData.length>0){
      const firstRow = lastDaybookData[0];

      const lastEntryDate = new Date(firstRow.daybook_date!);
      const today = new Date();
      
      const isSameDate =
        lastEntryDate.getFullYear() === today.getFullYear() &&
        lastEntryDate.getMonth() === today.getMonth() &&
        lastEntryDate.getDate() === today.getDate();

      if (isSameDate) {
        Utility.Message.Warning(["Today's daybook already submitted"],setMessage);
        return; 
      }
    }

    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      daybook_denomination: JSON.stringify(Utility.Clean.Object(denominationData)),
      daybook_data: JSON.stringify(Object.values(paymentModeData)),
    });

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  //
  const handleFieldChange = (
    segmentValue: number,
    field: keyof PaymentMode,
    newValue: number | null
  ) => {
    setPaymentModeData((prev) =>
      prev.map((item) =>
        item.segment === String(segmentValue) ? { ...item, [field]: newValue } : item
      )
    );
  };

  useEffect(() => {
    const total = 
    (denominationData.dollar100 ?? 0) * 100 +
    (denominationData.dollar50 ?? 0) * 50 +
    (denominationData.dollar20 ?? 0) * 20 +
    (denominationData.dollar10 ?? 0) * 10 +
    (denominationData.dollar5 ?? 0) * 5 +
    (denominationData.dollar2 ?? 0) * 2 +
    (denominationData.dollar1 ?? 0) * 1 +
    (denominationData.cent50 ?? 0) * 0.5 +
    (denominationData.cent25 ?? 0) * 0.25 +
    (denominationData.cent10 ?? 0) * 0.1 +
    (denominationData.cent5 ?? 0) * 0.05;

    setDenominationTotal(total);
  }, [denominationData]);

  useEffect(() => {
    console.log("paymentModeData:", paymentModeData);
  }, [paymentModeData]);

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} Privilege={Privilege} />
          <Control.Tab.Header titles={["Daybook Summary"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Title size={[0,83,0]}  />
                <Field.Date id={Name.Daybook.Date} value={formData.daybook_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} require={true} currentDate={true}  />
              </Control.Row>
              <Control.Flex>
                <Field.Title size={[0,15,0]} />
                <Field.Title size={[0,17,1]} title={Title.Terminal} align={Code.Align.CENTER} />
                <Field.Title size={[0,17,1]} title={"Govt/Insurance"} align={Code.Align.CENTER} />
                <Field.Title size={[0,17,1]} title={Title.Cash} align={Code.Align.CENTER} />
                <Field.Title size={[0,17,1]} title={Title.Cheque} align={Code.Align.CENTER} />
                <Field.Title size={[0,17,1]} title={Title.Total} align={Code.Align.CENTER} />
              </Control.Flex>
              {segmentOptions.map((segment) => {
                const current = paymentModeData?.find((d) => d.segment === String(segment.value)) || {};
                const key = `daybook_amount${segment.value}` as keyof Daybook;
                (formData[key] as number) = Number(current.terminal || 0) + Number(current.insurance || 0) + Number(current.cash || 0) + Number(current.check || 0);
                return (
                  <Control.Flex key={segment.value}>
                    <Field.Title size={[0,15,0]} title={segment.label} />
                    <Field.Amount id={Name.Daybook.terminal} value={current.terminal || 0} onChange={(e) => handleFieldChange(segment.value, "terminal", Number(e.target.value))} size={[0,17,1]} disabled={true} />
                    <Field.Amount id={Name.Daybook.insurance} value={current.insurance || 0} onChange={(e) => handleFieldChange(segment.value, "insurance", Number(e.target.value))} size={[0,17,1]} disabled={true} />
                    <Field.Amount id={Name.Daybook.cash} value={current.cash || 0} onChange={(e) => handleFieldChange(segment.value, "cash", Number(e.target.value))} size={[0,17,1]}  disabled={true} />
                    <Field.Amount id={Name.Daybook.check} value={current.check || 0} onChange={(e) => handleFieldChange(segment.value, "check", Number(e.target.value))} size={[0,17,1]} disabled={true} />
                    <Field.Amount id={Name.Daybook.total} value={Number(current.terminal || 0) + Number(current.insurance || 0) + Number(current.cash || 0) + Number(current.check || 0) } size={[0,17,1]} disabled={true} />
                  </Control.Flex>
                );
              })}
              <Control.Row>
                <Field.Title size={[0,15,0]} title='Total' />
                <Field.Amount id={Name.Daybook.TerminalTotal} value={formData.daybook_terminal_total || 0} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={true} />
                <Field.Amount id={Name.Daybook.InsuranceTotal} value={formData.daybook_insurance_total || 0} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={true} />
                <Field.Amount id={Name.Daybook.CashTotal} value={formData.daybook_cash_total || 0} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={true} />
                <Field.Amount id={Name.Daybook.CheckTotal} value={formData.daybook_check_total || 0} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={true} />
                <Field.Amount id={Name.Daybook.GrandTotal} value={formData.daybook_grand_total || 0} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={true} />
              </Control.Row>
              <Control.Separator Top={4} Bottom={4} />
              <Control.Row>
                <Field.Title size={[0,15,0]} />
                <Field.Amount id={Name.Daybook.PayoutTotal} value={formData.daybook_payout_total || 0} title={Title.Payout} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={false} />
                <Field.Amount id={Name.Daybook.GiftTotal} value={formData.daybook_gift_total || 0} title={"Gift Card"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={false} />
                <Field.Amount id={Name.Daybook.CommissionTotal} value={formData.daybook_commission_total || 0} title={"Commission"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={false} />
              </Control.Row>
              <Control.Row>
                <Field.Title size={[0,15,0]} />
                <Field.Amount id={Name.Daybook.CashOpen} value={formData.daybook_cash_opening || 0} title={"Opening Cash"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={false} />
                <Field.Amount id={Name.Daybook.CashInHand} value={formData.daybook_cash_in_hand || 0} title={"Closing Cash"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,1]} disabled={false} />
                <Field.Title size={[0,34,0]} title='' align={Code.Align.CENTER} />
                <Field.Amount id={Name.Daybook.CashAdjustment} value={formData.daybook_cash_adjustment || 0} title={"Cash Adjustment"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,17,0]} disabled={false} />
              </Control.Row>
              <Control.Separator Top={4} Bottom={4} />
              <Control.Row>
                <Field.Number id={Name.Daybook.dollar100} value={Utility.Get.FieldValue(denominationData, Code.Denomination.dollar100 as keyof Denomination) || 0} title={"$100"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.dollar50} value={Utility.Get.FieldValue(denominationData, Code.Denomination.dollar50 as keyof Denomination) || 0} title={"$50"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.dollar20} value={Utility.Get.FieldValue(denominationData, Code.Denomination.dollar20 as keyof Denomination) || 0} title={"$20"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.dollar10} value={Utility.Get.FieldValue(denominationData, Code.Denomination.dollar10 as keyof Denomination) || 0} title={"$10"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.dollar5} value={Utility.Get.FieldValue(denominationData, Code.Denomination.dollar5 as keyof Denomination) || 0} title={"$5"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.dollar2} value={Utility.Get.FieldValue(denominationData, Code.Denomination.dollar2 as keyof Denomination) || 0} title={"$2"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.dollar1} value={Utility.Get.FieldValue(denominationData, Code.Denomination.dollar1 as keyof Denomination) || 0} title={"$1"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.cent50} value={Utility.Get.FieldValue(denominationData, Code.Denomination.cent50 as keyof Denomination) || 0} title={"¢50"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.cent25} value={Utility.Get.FieldValue(denominationData, Code.Denomination.cent25 as keyof Denomination) || 0} title={"¢25"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.cent10} value={Utility.Get.FieldValue(denominationData, Code.Denomination.cent10 as keyof Denomination) || 0} title={"¢10"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number id={Name.Daybook.cent5} value={Utility.Get.FieldValue(denominationData, Code.Denomination.cent5 as keyof Denomination) || 0} title={"¢5"} onChange={(e) => Form.MultiValue.Change(e, denominationData, setDenominationData)} size={[0,8,1]} align={Code.Align.CENTER} />
                <Field.Number value={denominationTotal} title={"Total"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,12,1]} align={Code.Align.CENTER} disabled={true} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Daybook.Comment} value={formData.daybook_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
            </Control.Tab.Content>
            
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default DaybookForm;